import React from "react";

/**
 * ─── Tabs ─────────────────────────────────────────────────────────────────
 * Horizontal (default) or vertical tab primitive.
 *
 * Props
 *   value        active tab key (controlled)
 *   onChange     (key) => void
 *   tabs         Array<{ key, label, count?, icon?, disabled? }>
 *   orientation  "horizontal" | "vertical"    default "horizontal"
 *   ariaLabel    string   — tablist aria-label
 *   testId
 *
 * Accessibility
 *   role="tablist" · role="tab" · aria-selected on active · aria-controls
 *   (caller wires their own panels)
 */
export default function Tabs({
  value, onChange, tabs = [], orientation = "horizontal",
  ariaLabel = "Tabs", testId,
}) {
  return (
    <div
      className={`ds-tabs ds-tabs--${orientation}`}
      role="tablist"
      aria-orientation={orientation}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {tabs.map(t => (
        <button
          key={t.key}
          role="tab"
          className="ds-tab"
          aria-selected={value === t.key}
          disabled={t.disabled}
          onClick={() => !t.disabled && onChange?.(t.key)}
          data-testid={testId ? `${testId}-tab-${t.key}` : undefined}
        >
          {t.icon && <span aria-hidden style={{ display: "inline-flex" }}>{t.icon}</span>}
          <span>{t.label}</span>
          {t.count !== undefined && <span className="ds-tab__count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
